import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from './index';
import {AnswersDbService} from '../services/answers-db.service';
import {AnswerActions} from './action-types';
import {concatMap, map} from 'rxjs/operators';
import {answersLoaded} from './answers.actions';
import {LoadingService} from '../shared/services/loading.service';


@Injectable({
  providedIn: "root"
})
export class AnswersEffects {
  private actions$ = inject(Actions);
  private loading = inject(LoadingService);
  private store = inject<Store<AppState>>(Store);
  private answersDB = inject(AnswersDbService);


  loadAnswers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnswerActions.loadAnswers),
      concatMap(action => this.loading.showLoaderUntilCompleted(this.answersDB.loadAnswers(action.courseId, action.lessonId, action.questionId))),
      map(answers => answersLoaded({answers}))
    )
  );

  addNewAnswer$ = createEffect( () =>
      this.actions$.pipe(
        ofType(AnswerActions.addNewAnswer),
        concatMap(action => this.answersDB.createNewAnswer(action.answer.courseId, action.answer.questionId, action.answer.id, action.answer))
      )
    , {dispatch: false});

  deleteAnswer$ = createEffect( () =>
      this.actions$.pipe(
        ofType(AnswerActions.deleteAnswer),
        concatMap(action => this.answersDB.deleteAnswer(action.courseId, action.questionId, action.answerId))
      )
    , {dispatch: false});

  editAnswer$ = createEffect( () =>
      this.actions$.pipe(
        ofType(AnswerActions.editAnswer),
        concatMap(action => this.answersDB.updateAnswer(action.courseId, action.questionId, action.update))
      )
    , {dispatch: false});

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {




  }

}
